export default {
  container: {
    maxWidth: '500px'
  }
}
